import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook that listens for Ctrl+Shift+A keyboard shortcut to navigate to admin panel
 * This provides a hidden way to access admin without exposing the link publicly
 */
export function useAdminShortcut() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+Shift+A (Windows/Linux) or Cmd+Shift+A (Mac)
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'a') {
        event.preventDefault();
        navigate('/admin');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);
}
